module.exports = __webpack_public_path__ + "media/assets/images/personas/beatrice_schema-bc66caa638ae4cc1ed791f00a877e4a5.png";